export function shouldShowMIAWChat(channel = "", location = "") {
  const validLocations = [
    "contact-us | problemsWithProduct | electrical | thirtyDaysOrLess",
    "contact-us | problemsWithProduct | electrical | overThirtyDays",
    "returns | returningAnItem | large | faulty",
    "returns | returningAnItem | small | faulty | yes",
    "returns | returningAnItem | small | faulty | no",
  ];
  return channel === "TechnicalSupport" && validLocations.some(l => location.includes(l));
}
